import React from 'react';
import type { PdfTextSearchHit } from '../../utils/pdfTextSearch';

export function PdfSearchHits({
  hits,
  activeIndex,
}: {
  hits: PdfTextSearchHit[];
  activeIndex: number;
}) {
  if (hits.length === 0) return null;
  return (
    <svg className="pdf-search-hits" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden>
      {hits.map((hit, i) => (
        <rect
          key={`${hit.pageNumber}-${hit.itemIndex}-${i}`}
          x={hit.x}
          y={hit.y}
          width={Math.max(0.4, hit.width)}
          height={Math.max(0.6, hit.height)}
          className={`pdf-search-hit${i === activeIndex ? ' is-active' : ''}`}
        />
      ))}
    </svg>
  );
}
